<template>
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
  >
    <path
      d="M23.0024 7.789H25.7541V3.13464C24.4218 2.9961 23.0831 2.92771 21.7437 2.92973C17.7626 2.92973 15.0402 5.35937 15.0402 9.80882V13.6435H10.5469V18.8541H15.0402V32.2025H20.4264V18.8541H24.9051L25.5784 13.6435H20.4264V10.3211C20.4264 8.78428 20.8362 7.789 23.0024 7.789Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup>
defineProps({ className: String });
</script>
